import service from '@/services/payment-conditions/PaymentConditionsService'

export const paymentConditionsModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    defaultCTsList: [],
    paymentConditionsList: [],
    paymentCondition: {},
    loadingItems: false,
    pagination: {
      currentPage: 1,
      lastPage: 1,
      perPage: 10,
    },
  },
  mutations: {
    SET_PAYMENT_CONDITIONS(state, payload) {
      if (payload && payload.current_page) {
        state.pagination.currentPage = payload.current_page
        state.pagination.lastPage = payload.last_page
      }
      state.paymentConditionsList =
        payload && payload.data ? payload.data : payload
    },
    SET_PAYMENT_CONDITION(state, payload) {
      state.paymentCondition = payload
    },
    SET_CTS_LIST(state, payload) {
      state.defaultCTsList = payload
    },
    SET_LOADING_ITEMS(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async getValidCTs({ commit }) {
      let response = await service.getValidCTs()
      commit('SET_CTS_LIST', response)
    },

    async getPaymentConditionsAPI({ commit }, query = null) {
      try {
        commit('SET_LOADING_ITEMS')
        const response = await service.getPaymentConditionsAPI(query)
        commit('SET_PAYMENT_CONDITIONS', response)
      } finally {
        commit('SET_LOADING_ITEMS')
      }
    },

    async getPaymentConditionAPI({ commit }, id) {
      const response = await service.getPaymentConditionAPI(id)
      commit('SET_PAYMENT_CONDITION', response)
    },

    async deletePaymentConditionAPI({ dispatch, state }, id) {
      const { status } = await service.delete(id)
      dispatch('getPaymentConditionsAPI', {
        page: state.pagination.current_page,
      })
      return status
    },

    async updatePaymentConditionAPI({ dispatch, state }, payload) {
      const { status } = await service.update(payload.data, payload.id)
      dispatch('getPaymentConditionsAPI', {
        page: state.pagination.current_page,
      })
      return status
    },

    async insertPaymentConditionAPI({ dispatch, state }, payload) {
      const { status } = await service.insert(payload)
      dispatch('getPaymentConditionsAPI', {
        page: state.pagination.current_page,
      })
      return status
    },
  },
  getters: {
    getComboBoxList: (state) => {
      let comboBox = state.paymentConditionsList.map((item) => {
        return {
          ...item,
          DESCRICAO: item.CODIGO + ' - ' + item.NOME,
          CTS: item.CTS ? item.CTS.split(',').filter((n) => n) : [],
        }
      })
      return comboBox
    },
  },
}
